/**
 * Shared types for Kin application
 * These types are used across both frontend and backend
 */
// User roles in a family
export var FamilyRole;
(function (FamilyRole) {
    FamilyRole["OWNER"] = "OWNER";
    FamilyRole["MEMBER"] = "MEMBER";
    FamilyRole["VIEWER"] = "VIEWER";
})(FamilyRole || (FamilyRole = {}));
// Task status
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus["PENDING"] = "PENDING";
    TaskStatus["DONE"] = "DONE";
    TaskStatus["OVERDUE"] = "OVERDUE";
})(TaskStatus || (TaskStatus = {}));
/**
 * @deprecated Use RecurrenceRule instead. Kept for backward compatibility.
 */
export var RecurrencePattern;
(function (RecurrencePattern) {
    RecurrencePattern["DAILY"] = "DAILY";
    RecurrencePattern["WEEKLY"] = "WEEKLY";
    RecurrencePattern["MONTHLY"] = "MONTHLY";
})(RecurrencePattern || (RecurrencePattern = {}));
// Medication log status
export var MedicationLogStatus;
(function (MedicationLogStatus) {
    MedicationLogStatus["TAKEN"] = "TAKEN";
    MedicationLogStatus["MISSED"] = "MISSED";
    MedicationLogStatus["SKIPPED"] = "SKIPPED";
})(MedicationLogStatus || (MedicationLogStatus = {}));
// Day of week for medication schedules
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
// Task visibility for care homes
export var TaskVisibility;
(function (TaskVisibility) {
    TaskVisibility["PUBLIC"] = "PUBLIC";
    TaskVisibility["STAFF_ONLY"] = "STAFF_ONLY";
    TaskVisibility["ASSIGNED_CARERS"] = "ASSIGNED_CARERS";
})(TaskVisibility || (TaskVisibility = {}));
// Family link request direction
export var LinkRequestDirection;
(function (LinkRequestDirection) {
    LinkRequestDirection["FAMILY_TO_CAREHOME"] = "FAMILY_TO_CAREHOME";
    LinkRequestDirection["CAREHOME_TO_FAMILY"] = "CAREHOME_TO_FAMILY";
})(LinkRequestDirection || (LinkRequestDirection = {}));
// Family link request status
export var LinkRequestStatus;
(function (LinkRequestStatus) {
    LinkRequestStatus["PENDING"] = "PENDING";
    LinkRequestStatus["APPROVED"] = "APPROVED";
    LinkRequestStatus["REJECTED"] = "REJECTED";
})(LinkRequestStatus || (LinkRequestStatus = {}));
// Activity types for the activity feed
export var ActivityType;
(function (ActivityType) {
    ActivityType["TASK_CREATED"] = "TASK_CREATED";
    ActivityType["TASK_COMPLETED"] = "TASK_COMPLETED";
    ActivityType["TASK_REASSIGNED"] = "TASK_REASSIGNED";
    ActivityType["MEDICATION_LOGGED"] = "MEDICATION_LOGGED";
    ActivityType["APPOINTMENT_CREATED"] = "APPOINTMENT_CREATED";
    ActivityType["MEMBER_JOINED"] = "MEMBER_JOINED";
    ActivityType["INVITE_SENT"] = "INVITE_SENT";
    ActivityType["DIARY_ENTRY"] = "DIARY_ENTRY";
    // Care Home specific
    ActivityType["STAFF_JOINED"] = "STAFF_JOINED";
    ActivityType["STAFF_SCHEDULE_UPDATED"] = "STAFF_SCHEDULE_UPDATED";
    ActivityType["FAMILY_LINKED"] = "FAMILY_LINKED";
    ActivityType["FAMILY_UNLINKED"] = "FAMILY_UNLINKED";
    // Custody
    ActivityType["CUSTODY_SCHEDULE_CREATED"] = "CUSTODY_SCHEDULE_CREATED";
    ActivityType["CUSTODY_OVERRIDE_ADDED"] = "CUSTODY_OVERRIDE_ADDED";
    ActivityType["HANDOVER_CONFIRMED"] = "HANDOVER_CONFIRMED";
    ActivityType["HANDOVER_MISSED"] = "HANDOVER_MISSED";
    // Scheduled Activities
    ActivityType["SCHEDULED_ACTIVITY_CREATED"] = "SCHEDULED_ACTIVITY_CREATED";
    ActivityType["SCHEDULED_ACTIVITY_UPDATED"] = "SCHEDULED_ACTIVITY_UPDATED";
    ActivityType["SCHEDULED_ACTIVITY_CANCELLED"] = "SCHEDULED_ACTIVITY_CANCELLED";
})(ActivityType || (ActivityType = {}));
// Entity types for activity tracking
export var EntityType;
(function (EntityType) {
    EntityType["TASK"] = "TASK";
    EntityType["MEDICATION"] = "MEDICATION";
    EntityType["APPOINTMENT"] = "APPOINTMENT";
    EntityType["FAMILY_MEMBER"] = "FAMILY_MEMBER";
    EntityType["INVITE"] = "INVITE";
    EntityType["DIARY"] = "DIARY";
    // Care Home specific
    EntityType["STAFF"] = "STAFF";
    EntityType["SCHEDULE"] = "SCHEDULE";
    EntityType["FAMILY_LINK"] = "FAMILY_LINK";
    EntityType["INTERNAL_TASK"] = "INTERNAL_TASK";
    // Messaging
    EntityType["CONVERSATION"] = "CONVERSATION";
    EntityType["MESSAGE"] = "MESSAGE";
    // Custody
    EntityType["CUSTODY_SCHEDULE"] = "CUSTODY_SCHEDULE";
    EntityType["CUSTODY_HANDOVER"] = "CUSTODY_HANDOVER";
    // Scheduled Activities
    EntityType["SCHEDULED_ACTIVITY"] = "SCHEDULED_ACTIVITY";
})(EntityType || (EntityType = {}));
// Conversation type
export var ConversationType;
(function (ConversationType) {
    ConversationType["RESIDENT"] = "RESIDENT";
    ConversationType["CARE_HOME"] = "CARE_HOME";
    ConversationType["FAMILY"] = "FAMILY";
})(ConversationType || (ConversationType = {}));
// Message type / priority
export var MessageType;
(function (MessageType) {
    MessageType["NORMAL"] = "NORMAL";
    MessageType["URGENT"] = "URGENT";
    MessageType["SYSTEM"] = "SYSTEM";
})(MessageType || (MessageType = {}));
// Custody pattern types
export var CustodyPatternType;
(function (CustodyPatternType) {
    CustodyPatternType["WEEKLY"] = "WEEKLY";
    CustodyPatternType["ALTERNATING"] = "ALTERNATING";
    CustodyPatternType["ROTATING"] = "ROTATING";
    CustodyPatternType["CUSTOM"] = "CUSTOM";
})(CustodyPatternType || (CustodyPatternType = {}));
// Handover status
export var HandoverStatus;
(function (HandoverStatus) {
    HandoverStatus["PENDING"] = "PENDING";
    HandoverStatus["CONFIRMED"] = "CONFIRMED";
    HandoverStatus["LATE"] = "LATE";
    HandoverStatus["MISSED"] = "MISSED";
})(HandoverStatus || (HandoverStatus = {}));
// ==========================================
// Scheduled Activity types
// ==========================================
export var ActivityCategory;
(function (ActivityCategory) {
    ActivityCategory["SPORT"] = "SPORT";
    ActivityCategory["MUSIC"] = "MUSIC";
    ActivityCategory["ACADEMIC"] = "ACADEMIC";
    ActivityCategory["SOCIAL"] = "SOCIAL";
    ActivityCategory["MEDICAL"] = "MEDICAL";
    ActivityCategory["TRANSPORT"] = "TRANSPORT";
    ActivityCategory["OTHER"] = "OTHER";
})(ActivityCategory || (ActivityCategory = {}));
export var ScheduledActivityStatus;
(function (ScheduledActivityStatus) {
    ScheduledActivityStatus["ACTIVE"] = "ACTIVE";
    ScheduledActivityStatus["PAUSED"] = "PAUSED";
    ScheduledActivityStatus["ENDED"] = "ENDED";
})(ScheduledActivityStatus || (ScheduledActivityStatus = {}));
// ==========================================
// Check-in types
// ==========================================
export var MoodLevel;
(function (MoodLevel) {
    MoodLevel["GREAT"] = "GREAT";
    MoodLevel["GOOD"] = "GOOD";
    MoodLevel["OKAY"] = "OKAY";
    MoodLevel["LOW"] = "LOW";
    MoodLevel["POOR"] = "POOR";
})(MoodLevel || (MoodLevel = {}));
export var EnergyLevel;
(function (EnergyLevel) {
    EnergyLevel["HIGH"] = "HIGH";
    EnergyLevel["NORMAL"] = "NORMAL";
    EnergyLevel["LOW"] = "LOW";
    EnergyLevel["VERY_LOW"] = "VERY_LOW";
})(EnergyLevel || (EnergyLevel = {}));
// ==========================================
// Preparedness Checklist types
// ==========================================
export var PrepListCategory;
(function (PrepListCategory) {
    PrepListCategory["HOME_SAFETY"] = "HOME_SAFETY";
    PrepListCategory["HOSPITAL_DISCHARGE"] = "HOSPITAL_DISCHARGE";
    PrepListCategory["EMERGENCY_PLAN"] = "EMERGENCY_PLAN";
    PrepListCategory["MEDICATION_REVIEW"] = "MEDICATION_REVIEW";
})(PrepListCategory || (PrepListCategory = {}));
